module.exports = __webpack_public_path__ + "b298a9d1fd934c9f94e8c76757a25aa5.fbx";